<script>
import Changes from "@wielink-application/shared/js/mixins/changes";
import {useForm} from "@inertiajs/vue3";
import InputFile from "@/pages/components/form/horizontal/file.vue";
import InputOnly from "@/pages/components/form/input-only/input.vue";
import AssetMetadataFields from "@wielink-application/asset/vue/assets/AssetMetadataFields.vue";

export default {
    mixins: [Changes],
    components: {InputFile, InputOnly, AssetMetadataFields},
    props: {
        accept: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            fileRequired: true,
            form: useForm({
                'title': '',
                'base64': '',
                'assetable_group': '',
                'assetable_id': '',
                'assetable_type': '',
                'asset_id': null,
                'metadata': {}
            })
        }
    },
    methods: {
        async onUpdateModelValue(value) {
            if (value?.name) {
                this.form.title = value.name.replace(/\..*$/, '')
                return;
            }

            this.form.title = '';
            this.fileRequired = true;

        },
        async setAsset(asset, data) {
            this.fileRequired = false;
            await this._prepareForm(data, {
                title: asset.title,
                asset_id: asset.id,
                metadata: asset.metadata || {},
                base64: asset.base64 ? {
                    base64: asset.base64,
                    name: asset.name,
                    size: asset.size,
                    type: asset.type,
                    lastModified: asset.lastModified
                } : {}
            });
        },

        async newAsset(data) {
            this.fileRequired = true;
            await this._prepareForm(data, {
                title: '',
                asset_id: null,
                metadata: {}
            });
        },

        async _prepareForm(data, assetData) {
            try {
                await this.$refs.metadataFields.loadMetadata(data.assetableGroup);

                const metadata = this.$refs.metadataFields.prepareMetadata(assetData.metadata);

                this.form.defaults({
                    assetable_group: data.assetableGroup,
                    assetable_id: data.assetableId,
                    assetable_type: data.assetableType,
                    base64: assetData.base64 ?? {},
                    title: assetData.title,
                    asset_id: assetData.asset_id,
                    metadata: metadata
                });

                this.form.reset();
            } catch (error) {
                console.error('Fout bij voorbereiden form:', error);
            }
        }
    }
}
</script>

<template>
    <Input
        v-model="form.title"
        :form="form"
        name="title"
        label="Titel van bestand"
        required
    />

    <InputOnly
        v-model="form.assetable_group"
        :form="form"
        name="assetable_group"
        type="hidden"
    />

    <InputFile
        v-model="form.base64"
        :form="form"
        name="base64"
        label="Bestand"
        :asset_id="form.asset_id"
        :required="fileRequired"
        :accept="accept"
        :show-camera="true"
        @update:modelValue="onUpdateModelValue"
    />

    <AssetMetadataFields
        ref="metadataFields"
        :form="form"
        :assetable-group="form.assetable_group"
    />
</template>